export const FAILSAFE_SENTINEL_PREFIX = "__NO_FAILSAFE__";

/**
 * Returns true only when `plaintext` is a real, non-empty, non-sentinel value
 * that is safe to attach as `_debugPlaintext` in a backup request.  Prevents a
 * failed-decrypt placeholder from being mirrored to the debug plaintext table
 * and poisoning the channel_shared failsafe read path.
 */
export function isBackupablePlaintext(plaintext: string | null | undefined): boolean {
  return !!plaintext && plaintext.length > 0 && !plaintext.startsWith(FAILSAFE_SENTINEL_PREFIX);
}
